<template>
	<div>
		<el-card class="searchItemFlex">
			<el-input
				v-model="queryParam.userName"
				placeholder="用户名称"
				size="mini"
				clearable></el-input>
			<el-select
				v-model="queryParam.depId"
				placeholder="用户权限部门"
				size="mini"
				clearable
				filterable>
				<el-option
					v-for="item in depList"
					:key="item.clid"
					:label="item.clname"
					:value="item.clid"></el-option>
			</el-select>
			<el-select
				v-model="queryParam.roleId"
				placeholder="用户角色"
				size="mini"
				clearable
				filterable>
				<el-option
					v-for="item in roleList"
					:key="item.roleId"
					:label="item.roleName"
					:value="item.roleId"></el-option>
			</el-select>
			<el-checkbox v-model="queryParam.showBannedUser" @change="getUserList">显示禁用用户</el-checkbox>
			<el-button type="primary" size="mini" @click="getUserList"
				><i class="el-icon-search"></i>&nbsp;查询</el-button
			>
			<el-button type="warning" size="mini" @click="reset"
				><i class="el-icon-refresh"></i>&nbsp;重置</el-button
			>
			<el-button
				class="right"
				type="success"
				size="mini"
				@click="changeAddUserVisible(true)"
				><i class="el-icon-plus"></i>&nbsp;添加用户</el-button
			>
		</el-card>
		<el-card>
			<el-table
				ref="UserTable"
				:data="userList"
				size="mini"
				border
				height="610"
				style="width: 100%"
				v-loading="userLoading"
				@sort-change="SortChange"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(255, 255, 255, 0.8)">
				<el-table-column
					prop="userId"
					label="登录名"
					show-overflow-tooltip
					width="120"></el-table-column>
				<el-table-column
					label="用户名"
					prop="userName"
					width="140"
					show-overflow-tooltip
					sortable="'custom'"></el-table-column>
				<el-table-column label="权限部门" width="260" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-tag
							v-if="scope.row.bmList.length <= 0"
							size="mini"
							type="danger"
							>无</el-tag
						>
						<span
							v-else
							v-for="(item, index) in scope.row.bmList"
							:key="item.clid"
							>{{ item.clname
							}}<span v-show="index < scope.row.bmList.length - 1"
								>|</span
							></span
						>
					</template>
				</el-table-column>
				<el-table-column label="用户角色" width="300" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-tag
							v-if="scope.row.roleList.length <= 0"
							size="mini"
							type="danger"
							>无</el-tag
						>
						<span
							v-else
							v-for="(item, index) in scope.row.roleList"
							:key="item.roleId"
							>{{ item.roleName
							}}<span v-show="index < scope.row.roleList.length - 1"
								>|</span
							></span
						>
					</template>
				</el-table-column>
				<el-table-column label="用户状态" width="100">
					<template slot-scope="scope">
						<el-tag type="success" size="mini" v-if="scope.row.status == 0"
							>启用中</el-tag
						>
						<el-tag type="danger" size="mini" v-else>禁用中</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="用户权限" width="140">
					<template slot-scope="scope">
						<el-popover placement="top" width="500" trigger="click">
							<el-table
								size="mini"
								border
								:data="scope.row.rightList"
								height="500">
								<el-table-column type="index" width="50"></el-table-column>
								<el-table-column
									width="130"
									property="rightName"
									label="权限名称"
									show-overflow-tooltip></el-table-column>
								<el-table-column
									width="300"
									property="notes"
									label="权限描述"
									show-overflow-tooltip></el-table-column>
							</el-table>
							<el-button slot="reference" size="mini" type="primary" plain
								>点击查看</el-button
							>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column label="操作" fixed="right" width="250">
					<template slot-scope="scope">
						<el-button
							type="primary"
							size="mini"
							v-show="scope.row.userId.trim() !== 'admin'"
							@click="modifyUser(scope.row)"
							>更新</el-button
						>
						<el-button
							type="success"
							size="mini"
							v-show="scope.row.userId.trim() !== 'admin'"
							v-if="scope.row.status != 0"
							@click="changeUserStatus(scope.row.userId, 0)"
							>启用</el-button
						>
						<el-button
							type="danger"
							size="mini"
							v-show="scope.row.userId.trim() !== 'admin'"
							v-else
							@click="changeUserStatus(scope.row.userId, 1)"
							>禁用</el-button
						>
						<el-button
							type="warning"
							size="mini"
							v-show="scope.row.userId.trim() !== 'admin'"
							@click="resetPwd(scope.row.userId, scope.row.userName)"
							>重置密码</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<!--分页部分-->
			<el-pagination
				background
				@size-change="pagesizeChange"
				@current-change="pagenumChange"
				:current-page="queryParam.pageNum"
				:page-sizes="[10, 50, 100, 200, 500]"
				:page-size="queryParam.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
				style="margin-top: 10px">
			</el-pagination>
		</el-card>

		<modify-user
			:bmList="depList"
			:rightList="rightList"
			:modifyVisible="modifyUserVisible"
			:flushUserList="getUserList"
			:flushRoleList="getRoleList"
			:modifyFormCp="modifyForm"
			:roleList="roleList"
			:canAddRole="userRightList.indexOf('role_manage') >= 0"
			@changeVisible="changeModifyUserVisible"></modify-user>

		<new-user
			:bmList="depList"
			:canAddRole="userRightList.indexOf('role_manage') >= 0"
			:flushRoleList="getRoleList"
			:flushUserList="getUserList"
			:newUserVisible="addUserVisible"
			:rightList="rightList"
			:roleList="roleList"
			:xmBmList="xmBmList"
			:zwList="zwList"
			@changeVisible="changeAddUserVisible"></new-user>
	</div>
</template>
<script>
import ModifyUser from "../../components/user/ModifyUser.vue"
import getRightList from "@/util/rightList.js"
import NewUser from "../../components/user/NewUser.vue"
export default {
	name: "userManage",
	components: { ModifyUser, NewUser },
	data() {
		return {
			queryParam: {
				userName: "",
				depId: "",
				showBannedUser: false,
				roleId: null,
				pageNum: 1,
				pageSize: 50,
				order: 0,
			},
			depList: [],
			roleList: [],
			userList: [],
			total: 0,
			userLoading: false,
			rightList: [],
			modifyUserVisible: false,
			modifyForm: {
				xmid: "",
				xmname: "",
				bmIdList: [],
				roleList: [],
			},
			userRightList: getRightList(),
			xmBmList: [],
			zwList: [],
			addUserVisible: false,
		}
	},
	mounted() {
		this.getUserList()
		this.getAclassList()
		this.getRoleList()
		this.getRightList()
		this.getxmBmList()
		this.getZwList()
	},
	methods: {
		//获取单选的部门列表
		async getxmBmList() {
			const { data: res } = await this.$http.post("item/xmBm").catch(err => err)
			if (res) {
				this.xmBmList = res
			}
		},
		//获取职务列表
		async getZwList() {
			const { data: res } = await this.$http.post("item/zw").catch(err => err)
			if (res) {
				this.zwList = res
			}
		},
		//获取部门列表
		async getAclassList() {
			const { data: res } = await this.$http.post("atimport/aclassList").catch(err => err)
			if (res) {
				this.depList = res
			}
		},
		//获取所有权限列表
		async getRightList() {
			const { data: res } = await this.$http.post("right/rightList").catch(err => err)
			if (res) {
				this.rightList = res
			}
		},
		//获取角色列表
		async getRoleList() {
			const { data: res } = await this.$http.post("item/roles").catch(err => err)
			if (res) {
				this.roleList = res
			}
		},
		async getUserList() {
			this.userLoading = true
			const { data: res } = await this.$http.post("um/list", this.queryParam).catch(err => err)
			if (res) {
				this.userList = res.userItemList
				this.total = res.total
			}
			this.userLoading = false
		},
		reset() {
			this.queryParam = {
				userName: "",
				depId: "",
				showBannedUser: false,
				roleId: null,
				pageNum: 1,
				pageSize: 50,
				order: 0,
			}
			this.$refs.UserTable.columns.forEach(item => {
				item.order = ""
			})
			this.getUserList()
		},
		SortChange(column) {
			if (column.order == "ascending" || column.order == null) {
				this.queryParam.order = 0
			} else {
				this.queryParam.order = 1
			}
			this.getUserList()
		},
		pagesizeChange(newSize) {
			this.queryParam.pageSize = newSize
			this.queryParam.pageNum = 1
			this.getUserList()
		},
		pagenumChange(newNum) {
			this.queryParam.pageNum = newNum
			this.getUserList()
		},
		modifyUser(row) {
			var str = JSON.stringify(row)
			var form = JSON.parse(str)
			var bmIdList = []
			for (var i = 0; i < form.bmList.length; i++) {
				bmIdList.push(form.bmList[i].clid)
			}
			var roleList = []
			for (var j = 0; j < form.roleList.length; j++) {
				roleList.push(form.roleList[j].roleId)
			}
			this.modifyForm = {
				xmid: form.userId,
				xmname: form.userName,
				bmIdList,
				roleList,
			}
			this.changeModifyUserVisible(true)
		},
		changeModifyUserVisible(val) {
			this.modifyUserVisible = val
		},
		changeAddUserVisible(val) {
			this.addUserVisible = val
		},
		async changeUserStatus(userId, status) {
			var text
			if (status == 0) {
				text = "将要启用用户，启用后可以正常进行登录，请确定是否继续？"
			} else {
				text = "将要禁用用户，禁用后用户无法进行登录，请确定是否继续？"
			}
			const confirmresult = await this.$confirm(text, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			}).catch(err => err)
			if (confirmresult !== "confirm") {
				return this.$message.info("操作已取消！")
			}
			const { data: res } = await this.$http.post("um/changeStatus", {
				userId,
				status,
			}).catch(err => err)
			if (res) {
				this.$message.success("操作成功！")
				this.getUserList()
			}
		},
		async resetPwd(userId, userName) {
			const confirmresult = await this.$confirm(
				"将要重置用户[" + userName + "]密码为[111111]，请确定是否继续？",
				"提示",
				{
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}
			).catch(err => err)
			if (confirmresult !== "confirm") {
				return this.$message.info("操作已取消")
			}
			const { data: res } = await this.$http.post("um/resetPwd", {
				data: userId,
			}).catch(err => err)
			if (res) {
				this.$message.success("操作成功！")
			}
		},
	},
}
</script>
<style scope></style>
